import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

class ShopService {
  getAllShopByManager(idUser) {
    return api.get(UtilsUrl.ShopPosURL() + "/getAllShopByManager/" + idUser);
  }
}
export default new ShopService();
